import { GetterTree } from "vuex";
import { ITransporterState } from "./state";
import { ITransporter } from "@/models";

export const getters: GetterTree<ITransporterState, any> = {
    getTransporters: (state) => (): ITransporter[] => {
        return state.transporters;
    },

    getTransporterById: (state) => (transporterId: number): ITransporter => {
        return state.transporters.find(x => x.transporterId === transporterId);
    },

    getActiveTransporters: (state) => (): ITransporter[] => {
        return state.activeTransporters;
    },
};
